(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mamba-shipping-estimator"] && !Shopify.designMode) return;
  try {
    function initializeMambaShipping(){
 document.querySelectorAll('[data-shipping-estimator]').forEach(box=>{
  if(box.dataset.ready)return;box.dataset.ready='true';
  const button=box.querySelector('[data-shipping-estimate]'),input=box.querySelector('[data-shipping-zip]'),result=box.querySelector('[data-shipping-result]'),strings=JSON.parse(box.querySelector('[data-shipping-strings]').textContent);
  button.addEventListener('click',async()=>{
   if(!/^[0-9]{5}$/.test(input.value.trim())){result.textContent=strings.invalid;input.focus();return;}
   button.disabled=true;result.textContent=strings.loading;
   try{
    const params=new URLSearchParams({'shipping_address[zip]':input.value.trim(),'shipping_address[country]':'France'});
    const response=await fetch(box.dataset.root+'cart/shipping_rates.json?'+params,{headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
    if(!response.ok)throw new Error('rates');
    const data=await response.json();
    result.textContent='';
    if(!data.shipping_rates?.length){result.textContent=strings.empty;return;}
    data.shipping_rates.forEach(rate=>{const line=document.createElement('div');line.textContent=rate.name+' : '+new Intl.NumberFormat('fr-FR',{style:'currency',currency:rate.currency||box.dataset.currency||'EUR'}).format(Number(rate.price));result.appendChild(line);});
   }catch(error){result.textContent=strings.error;}finally{button.disabled=false;}
  });
  input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();button.click();}});
 });
}
initializeMambaShipping();document.addEventListener('shopify:section:load',initializeMambaShipping);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mamba-size-help"] && !Shopify.designMode) return;
  try {
    (function(){
  function calculate(root){
    var heightInput=root.querySelector('[data-fit-height]');
    var weightInput=root.querySelector('[data-fit-weight]');
    var height=Number(heightInput.value),weight=Number(weightInput.value);
    var result=root.querySelector('.mamba-fit-calculator__result');
    heightInput.removeAttribute('aria-invalid');weightInput.removeAttribute('aria-invalid');
    if(!heightInput.value||!Number.isFinite(height)||height<140||height>220){
      heightInput.setAttribute('aria-invalid','true');result.textContent='Indique ta taille en centimètres, par exemple 178.';heightInput.focus();return;
    }
    if(!weightInput.value||!Number.isFinite(weight)||weight<35||weight>180){
      weightInput.setAttribute('aria-invalid','true');result.textContent='Indique ton poids en kilos, par exemple 77.';weightInput.focus();return;
    }
    if(height<160||height>195||weight<55||weight>100){
      result.textContent='Ton profil sort des repères de ce calculateur. Consulte les mesures détaillées ci-dessous pour choisir entre S et XL.';return;
    }
    var index=weight<65?0:weight<=77?1:weight<=87?2:3;
    if(height>183)index=Math.max(index,2);
    if(height>190)index=Math.max(index,3);
    var sizes=['S','M','L','XL'];
    result.replaceChildren();
    var cards=document.createElement('div');cards.className='mamba-fit-calculator__cards';
    [['Coupe serrée',sizes[index],'Suggestion'],['Moins serrée',index<3?sizes[index+1]:'—',index<3?'Plus d’aisance':'Au-delà du XL']].forEach(function(data){
      var card=document.createElement('div');card.className='mamba-fit-calculator__card';
      ['span','strong','span'].forEach(function(tag,i){var el=document.createElement(tag);el.textContent=data[i];card.appendChild(el);});cards.appendChild(card);
    });
    result.appendChild(cards);
    var note=document.createElement('p');note.textContent=index<3?'Une taille au-dessus offre généralement plus d’aisance. Le rashguard reste près du corps ; le maintien du short peut différer.':'Pour plus d’aisance, nous ne proposons pas de taille supérieure au XL. Vérifie les mesures avant de choisir.';result.appendChild(note);
  }
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-fit-calculate]');if(button)calculate(button.closest('.mamba-fit-calculator'));
  });
  document.addEventListener('input',function(event){
    if(event.target.matches('[data-fit-height],[data-fit-weight]'))event.target.closest('.mamba-fit-calculator').querySelector('.mamba-fit-calculator__result').replaceChildren();
  });
  document.addEventListener('keydown',function(event){
    if(event.key==='Enter'&&event.target.matches('[data-fit-height],[data-fit-weight]')){event.preventDefault();calculate(event.target.closest('.mamba-fit-calculator'));}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
